<template>
  <section id="about">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center" class="mt-n12">
            <v-col cols="12" md="7">
              <!-- <h1 class="font-weight-light display-2">How PharmaWRK </h1> -->
              <h1 class="font-weight-dark mb-3">
                How PharmaWRK helps Pharma Companies
              </h1>
              <br />

              <!-- <v-img
                    src="@/assets/img/icon1.svg"
                    max-width="40px"
                    class="mr-4"
                  /> -->
              <p>
                • ‎ ‎‎‎ Track field activities of pharma reps better
                <br /><br />
                • ‎ ‎‎‎ Easily manage coverage areas and territories
                <br /><br />
                • ‎ ‎ Manage drug related learning content<br /><br />
                • ‎ ‎ Gain insights into physician, pharmacy and stockist follow
                ups <br /><br />
                • ‎ ‎ Location based insight into activities at a macro level
                across all representatives<br /><br />
                • ‎ ‎ Mobile app to assist pharma reps to decide the best next
                visit plan
              </p>
              <!-- <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon2.svg"
                    max-width="40px"
                    class="mr-4"
                  />
                  <p >
                   Easily manage coverage areas and territories 
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon3.svg"
                    max-width="40px"
                    class="mr-4"
                  />
                  <p >
                   Manage drug related learning content
                  </p>
                </v-col>
            
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon4.svg"
                    max-width="40px"
                    class="mr-4"
                  />
                  <p >
                   Gain insights into physician, pharmacy and stockist <br>follow ups 
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon2.svg"
                    max-width="40px"
                    class="mr-4"
                  />
                  <p >
                   Location based insight into activities at a macro level across<br> all representatives
                  </p>
                </v-col>
                
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon6.svg"
                    max-width="40px"
                    class="mr-4"
                  />
                  <p >
                   Mobile app to assist pharma reps to decide the best next visit plan <br>based on previous visits
                  </p>
                </v-col> -->
            </v-col>
            <v-col cols="12" md="5" class="d-none d-md-flex">
              <v-img
                src="@/assets/img/ill1.png"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style scoped>
#about {
  padding-top: 30px;
  background-color: #f4f7f5;
}
</style>
